<template>
  <vx-card title="Contenido">
    <p>Aquí se puede modificar la información más relevante de la página.</p>

    <div v-if="initProgress" style="   margin-top: 1rem; width: 100%">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <div class="mt-5">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input @blur="content.title = trimString(content.title)" v-validate="'required'" name="title"
                    class="w-full" label="Titulo"
                    v-model="content.title"/>
          <span class="text-danger text-sm"
                v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea @blur="content.description = trimString(content.description)" v-validate="'required'"
                       name="description" label="Descripción"
                       v-model="content.description"/>
          <span class="text-danger text-sm"
                v-show="errors.has('description')">{{ errors.first('description') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.facebook = trimString(content.facebook)" v-validate="'required'"
                    name="facebook" class="w-full" label="Facebook"
                    v-model="content.facebook"/>
          <span class="text-danger text-sm"
                v-show="errors.has('facebook')">{{ errors.first('facebook') }}</span>
        </div>
        <div class="vx-col w-1/3">
          <vs-input @blur="content.instagram = trimString(content.instagram)" v-validate="'required'"
                    name="instagram" class="w-full" label="Instagram"
                    v-model="content.instagram"/>
          <span class="text-danger text-sm"
                v-show="errors.has('instagram')">{{ errors.first('instagram') }}</span>
        </div>
        <div class="vx-col w-1/3">
          <vs-input @blur="content.tiktok = trimString(content.tiktok)" v-validate="'required'"
                    name="instagram" class="w-full" label="Tiktok"
                    v-model="content.tiktok"/>
          <span class="text-danger text-sm"
                v-show="errors.has('tiktok')">{{ errors.first('tiktok') }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-1/3">
          <vs-input @blur="content.phone = trimString(content.phone)" v-validate="'required'"
                    name="phone" class="w-full" label="Telefono"
                    v-model="content.phone"/>
          <span class="text-danger text-sm"
                v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>
        <div class="vx-col w-1/3">
          <vs-input @blur="content.whatsApp = trimString(content.whatsApp)" v-validate="'required'"
                    name="whatsApp" class="w-full" label="WhatsApp"
                    v-model="content.whatsApp"/>
          <span class="text-danger text-sm"
                v-show="errors.has('whatsApp')">{{ errors.first('whatsApp') }}</span>
        </div>
        <div class="vx-col w-1/3">
          <vs-input @blur="content.email = trimString(content.email)" v-validate="'required'"
                    name="email" class="w-full" label="Email"
                    v-model="content.email"/>
          <span class="text-danger text-sm"
                v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>

      <!--Link destacado del menú-->
      <vs-divider/>
      <div class="mb-6">
        <h6 class="mb-4">Link destacado del menú</h6>
        <div class="mb-4">
          <label class="text-sm opacity-75">Mostrar link destacado</label>
          <vs-switch v-model="content.menuHighlightEnabled"/>
        </div>
        <div class="vx-row" v-if="content.menuHighlightEnabled">
          <div class="vx-col w-1/2">
            <vs-input @blur="content.menuHighlightText = trimString(content.menuHighlightText)"
                      name="menuHighlightText" class="w-full" label="Texto del link"
                      v-model="content.menuHighlightText"
                      placeholder="Ej: Papelería"/>
          </div>
          <div class="vx-col w-1/2">
            <vs-input @blur="content.menuHighlightLink = trimString(content.menuHighlightLink)"
                      name="menuHighlightLink" class="w-full" label="URL del link"
                      v-model="content.menuHighlightLink"
                      placeholder="Ej: /categories/papeleria"/>
          </div>
        </div>
      </div>
      <vs-divider/>
      <!--End-->

      <!--Pre banner-->
      <div class="vx-row mb-6">
        <div class="vx-col w-1/2">
          <vs-input @blur="content.prebannerText = trimString(content.prebannerText)"
                    name="prebannerText" class="w-full" label="Texto de banner superior"
                    v-model="content.prebannerText"/>
        </div>
        <div class="vx-col w-1/2">
          <vs-input @blur="content.prebannerLink = trimString(content.prebannerLink)"
                    name="prebannerLink" class="w-full" label="Slug de banner superior"
                    v-model="content.prebannerLink"/>
        </div>
      </div>

      <!--Hour Limit-->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input v-validate="'required'" name="title"
                    class="w-full" label="Hora límite"
                    v-model.number="content.limit"/>
          <span class="text-danger text-sm"
                v-show="errors.has('limit')">{{ errors.first('limit') }}</span>
        </div>
      </div>
      <!--End--->

      <!--Disabled dates-->
      <div class="mt-5">
        <h6 class="mb-4">Deshabilitar días</h6>
        <vc-date-picker
          mode='multiple'
          v-model='content.dates'/>
      </div>
      <!--End-->

      <!--Campaign mode--->
      <div class="mt-5">
        <label class="text-sm opacity-75">Modo campaña</label>
        <vs-switch v-model="content.campaignMode"/>
      </div>
      <!--End-->

      <!--Campaign name--->
     <div class="mt-5">
        <vs-input @blur="content.campaignName = trimString(content.campaignName)"
                  name="prebannerText" class="w-full" label="Nombre de campaña"
                  v-model="content.campaignName"/>
      </div>
      <!--End-->

      <!--Campaign dates-->
      <div class="mt-5 flex gap-4" v-if="content.campaignMode">
        <div class="w-1/2">
           <label class="text-sm opacity-75">Desde</label>
          <vc-date-picker
            is-range
            v-model='content.campaignDaysStart'/>
        </div>
        <div class="w-1/2">
          <label class="text-sm opacity-75">Hasta</label>
          <vc-date-picker
            is-range
            v-model='content.campaignDaysEnd'/>
        </div>
      </div>
      <!--End-->

      <!-- Products -->
      <div class="mt-5" v-if="content.campaignMode">
        <label class="vs-select--label" for="products">Selecciona productos de campaña</label>
        <v-select multiple id="products" :options="products"
                  v-model="content.campaignProducts"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" name="products"/>
        <span class="text-danger text-sm"
              v-show="errors.has('products')">{{ errors.first('products') }}</span>
      </div>
      <!--End-->

      <!--Pickup in store-->
      <vs-divider/>
      <div class="mt-5">
        <h6 class="mb-4">Recojo en tienda</h6>
        <div class="mb-4">
          <label class="text-sm opacity-75">Habilitar recojo en tienda</label>
          <vs-switch v-model="content.pickupEnabled"/>
        </div>

        <template v-if="content.pickupEnabled">
          <div v-for="(store, index) in content.pickupStores" :key="index"
               class="border border-solid border-grey-light rounded p-4 mb-4">
            <div class="flex justify-between items-center mb-3">
              <h6>Tienda {{ index + 1 }}</h6>
              <div class="flex items-center gap-2">
                <label class="text-sm opacity-75 mr-2">Activa</label>
                <vs-switch v-model="store.state"/>
                <vs-button color="danger" type="flat" icon="delete" size="small"
                           @click="removePickupStore(index)"/>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/2">
                <vs-input class="w-full" label="Nombre de tienda" v-model="store.name"
                          placeholder="Ej: Tienda San Isidro"/>
              </div>
              <div class="vx-col w-1/2">
                <vs-input class="w-full" label="Teléfono de contacto" v-model="store.phone"
                          placeholder="Ej: +51904313541"/>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Dirección" v-model="store.address"
                          placeholder="Ej: Calle Antequera 777, Oficina 101, San Isidro, Lima"/>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Horario" v-model="store.schedule"
                          placeholder="Ej: Lunes a Sábado de 11am a 4pm"/>
              </div>
            </div>
          </div>

          <vs-button type="border" icon="add" @click="addPickupStore">Agregar tienda</vs-button>
        </template>
      </div>
      <!--End-->

      <div class="flex mt-6 flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
        <div v-if="progress" style="   margin-top: 1rem; width: 100%">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </div>

    </div>
  </vx-card>
</template>

<script>
import trimString from '../mixins/trimString'

import { auth, db, FieldValue } from '@/firebase/firebaseConfig'

export default {
  name: 'Content',
  mixins: [
    trimString
  ],
  data() {
    return {
      content: {},
      progress: false,
      initProgress: false,
      products: []
    }
  },
  /**
   * Get data on firestore
   * @returns {Promise<void>}
   */
  async created() {
    try {
      this.initProgress = true
      await db.collection('content').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.content = {
            id: doc.id,
            ...doc.data(),
            campaignDaysStart: doc.data().campaignDaysStart.toDate(),
            campaignDaysEnd: doc.data().campaignDaysEnd.toDate(),
            pickupEnabled: doc.data().pickupEnabled || false,
            pickupStores: doc.data().pickupStores || [],
            menuHighlightEnabled: doc.data().menuHighlightEnabled || false,
            menuHighlightText: doc.data().menuHighlightText || '',
            menuHighlightLink: doc.data().menuHighlightLink || '',
          }
        })

        // eslint-disable-next-line no-unused-vars
        const newDates = []
        this.content.dates.forEach((d) => {
          newDates.push(d.toDate())
        })
        this.content.dates = newDates
        this.initProgress = false
      })

      await this.loadProducts()
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  computed: {
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    /**
     *  Save data in firestore
     */
    async submitData() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true

          // Content
          let contentRef = db.collection('content').doc(this.content.id)

          //Clone to remove the id
          let cloneContent = Object.assign({}, this.content)
          delete cloneContent.id

          await contentRef.update({
            ...cloneContent,
            uid: auth.currentUser.uid,
            updatedAt: FieldValue.serverTimestamp()
          })

          this.progress = false
          this.$vs.notify({
            color: 'success',
            title: 'Contenido',
            text: 'Contenido modificado correctamente.'
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Get products of firestore
     * @returns {Promise<void>}
     */
    addPickupStore() {
      if (!this.content.pickupStores) {
        this.content.pickupStores = []
      }
      this.content.pickupStores.push({
        id: Date.now().toString(),
        name: '',
        address: '',
        phone: '',
        schedule: '',
        state: true
      })
      this.$forceUpdate()
    },
    removePickupStore(index) {
      this.content.pickupStores.splice(index, 1)
      this.$forceUpdate()
    },
    async loadProducts() {
      const querySnapshot = await db.collection('products')
        .where('state', '==', true)
        .orderBy('createdAt', 'desc')
        .get()
      querySnapshot.forEach((doc) => {
        let product = {
          id: doc.id,
          ...doc.data(),
          featured: doc.data().featured || false,
          offer: doc.data().offer || false,
          best: doc.data().best || false,
          label: doc.data().sku + ' - ' + doc.data().name.substring(0, 30)
        }
        if (product.newProduct === undefined) {
          product.newProduct = false
        }
        this.products.push(product)
      })
    }
  }
}
</script>
